import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  getGenderText,
  getStatusColor,
  getStatusText,
} from "../../Common/Utils/statusUtils";
import search from "../../assets/images/search-lg.svg";
import { getUser, deleteUser } from "../../../redux/user/action";
import Filter from "../../Common/Filter/Filter";
import CardHeader from "../../Common/CardHeader/CardHeader";
import ModalDelete from "../../Common/Popup/ModalDelete";
import "../../Common/Styles/Listing.css";
import UserDelete from "./UserDelete";
import CategoryFilter from "../Category/CategoryFilter";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import { FaSortUp, FaSortDown } from "react-icons/fa";
import { usePermissions } from "../../../Hooks/usePermissions";
import { MENU, PERMISSION } from "../../../lib/permissions";
import ExportMenu from "../../Common/Export/ExportMenu";

const UserList = () => {
  const { hasAction } = usePermissions();
  const [params, setParams] = useState({
    page: 1,
    type: 1,
    search_key: "",
    status: "",
    per_page: "10",

  });
  const { t } = useTranslation();
  const userlist = useSelector(({ user: { userlist } }) => userlist);
  const [openFilter, setOpenFilter] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});
  console.log(currentComponent, "currentComponent");
  const [loading, setLoading] = useState(false);
  const [componentList, setComponentList] = useState([]);
  const pagination_meta = userlist?.pagination_meta;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log(userlist, "userlist");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortOrders, setSortOrders] = useState("asc");

  const handlePageChange = (newPage) => {
    setParams((prevParams) => ({
      ...prevParams,
      page: newPage,
    }));
  };

  const handleSortToggle = () => {
    setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  };
  const handleSortToggles = () => {
    setSortOrders((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  };

  useEffect(() => {
    if (userlist) {
      setComponentList(userlist.users || []);
    }
  }, [userlist]);

  useEffect(() => {
    dispatch(getUser(params));
  }, [dispatch, params]);

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteUser(currentComponent.id, setLoading, params));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  const addComponent = () => {
    navigate("/user/add");
  };

  const updateComponent = (id) => {
    navigate(`/user/update/${id}`);
    // navigate(`/saved`);
  };

  const handleASC = () => {
    const data = {
      ...params,
      created_on: 1,
      type: 1,
      page: 1,
    };
    setParams(data);
    dispatch(getUser(data));
  };

  const handleDESC = () => {
    const data = {
      ...params,
      created_on: 2,
      type: 1,
      page: 1,
    };
    setParams(data);
    dispatch(getUser(data));
  };

  const handlelostLoginasc = () => {
    const data = {
      ...params,
      last_login: 1,
      type: 1,
      page: 1,
    };
    setParams(data);
    dispatch(getUser(data));
  };

  const handlelostLogindesc = () => {
    const data = {
      ...params,
      last_login: 2,
      type: 1,
      page: 1,
    };
    setParams(data);
    dispatch(getUser(data));
  };

  const exportParams = {
    ...params,
    from_date: params.start_date,
    to_date: params.end_date,
  };

  // delete permissions

  const canDelete = hasAction(MENU.USER, PERMISSION.DELETE);



  return (
    <div className="card-head order-card">
      <div className="sub-head">
        <h4>Customer List</h4>
      </div>
      {/* <div
        onClick={() => setOpenFilter(false)}
        className={openFilter ? `overlay show` : "overlay"}
      ></div>
      <CategoryFilter
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        params={params}
        setParams={setParams}
      /> */}
      <CardHeader
        params={params}
        setParams={setParams}
        addmodel={addComponent}
        search={search}
        setOpenFilter={setOpenFilter}
        showFilter={false}
      />
      <div className="table-category mt-3">
        <div className="table-first-top d-flex justify-content-between align-items-center">
          
          <div className="d-flex justify-content-end align-items-center table-right">
            Filter by
            <select>
              <option value="">All</option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
            </select>













            <div className="">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                Export
              </button>

              <div
                className="modal fade"
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        Export Customers
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="offcanvas-body">
                        <div>
                          <label htmlFor="start_date">Start Date</label>
                          <input
                            type="date"
                            id="start_date"
                            className="form-control"
                            value={params.start_date || ""}
                            onChange={(e) =>
                              setParams((prev) => ({ ...prev, start_date: e.target.value }))
                            }
                          />
                        </div>

                        <div>
                          <label htmlFor="end_date">End Date</label>
                          <input
                            type="date"
                            id="end_date"
                            className="form-control"
                            value={params.end_date || ""}
                            onChange={(e) =>
                              setParams((prev) => ({ ...prev, end_date: e.target.value }))
                            }
                          />
                        </div>

                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <ExportMenu
                          resource="customers"
                          params={exportParams}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="table-sec table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Full Name</th>
                {/* <th scope="col">National Id</th> */}
                <th scope="col">Contact</th>
                <th scope="col">
                  Created On{" "}
                  <button onClick={handleSortToggle} className="up-down-btn">
                    {sortOrder === "asc" ? (
                      <FaSortDown onClick={() => handleASC()} />
                    ) : (
                      <FaSortUp onClick={() => handleDESC()} />
                    )}
                  </button>
                </th>
                {/* <th scope="col">
                  Last Login{" "}
                  <button onClick={handleSortToggles} className="up-down-btn">
                    {sortOrders === "asc" ? (
                      <FaSortDown onClick={() => handlelostLoginasc()} />
                    ) : (
                      <FaSortUp onClick={() => handlelostLogindesc()} />
                    )}
                  </button>
                </th> */}
                {/* <th scope="col">Gender</th> */}
                <th scope="col">Status</th>
                <th scope="col" className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {componentList.length > 0 ? (
                componentList.map((item, index) => (
                  <tr key={index}>
                    <td> {index + 1 + (params?.page - 1) * 10}</td>
                    <td>
                      {item?.full_name === "None None" ? "" : item?.full_name}
                    </td>
                    {/* <td>{item?.national_id}</td> */}
                    <td>
                      <p>
                        {item?.country_code} {item?.mobile_number}
                      </p>
                      <p>{item?.email_id}</p>
                    </td>
                    <td>
                      {item?.created_on ? item.created_on.split(" ")[0] : "N/A"}
                    </td>
                    {/* <td>
                      {item.last_login_date == null ? "" : item.last_login_date}
                    </td> */}
                    {/* <td>
                    {item.gender === 1
                      ? "Male"
                      : item.gender === 2
                      ? "Female"
                      : item.gender === 3
                      ? "Both"
                      : ""}
                  </td> */}
                    <td
                      style={{
                        color:
                          item.status === 1
                            ? "#12b812"
                            : item.status === 2
                              ? "red"
                              : "inherit",
                      }}
                    >
                      <div
                        className=""
                        style={{
                          backgroundColor:
                            item.status === 1
                              ? "#16d11630"
                              : item.status === 2
                                ? "#ff000026"
                                : "inherit",
                          padding: "3px 25px",
                          borderRadius: "50px",
                          textAlign: "center",
                          width: "fit-content",
                        }}
                      >
                        {item.status === 1
                          ? "Active"
                          : item.status === 2
                            ? "Inactive"
                            : ""}
                      </div>
                    </td>

                    <td>
                      <div class="dropdown d-flex justify-content-center">
                        <button
                          class="dropdown-action-btn dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Action
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            class="dropdown-item"
                            onClick={() => updateComponent(item.id)}
                          >
                            Edit
                          </a>
                          {canDelete && (
                            <a
                              class="dropdown-item"
                              onClick={() => {
                                setModal(true);
                                setCurrentComponent(item);
                              }}
                            >
                              Delete
                            </a>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Users Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Pagination Component */}
        <div className="pagination-section">
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-3">
              <select
                className="form-select"
                value={params.per_page || 10}
                onChange={(e) =>
                  setParams((prev) => ({
                    ...prev,
                    page: 1, // reset to first page when changing per_page
                    per_page: e.target.value,
                  }))
                }
                style={{ width: "100px" }}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            {pagination_meta && (
              <CommonPagination
                currentPage={pagination_meta.current_page}
                totalPages={pagination_meta.pages}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </div>
      </div>
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <UserDelete
          modalTitle={"User"}
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}
        />
      </Modal>
    </div>
  );
};

export default UserList;
